module.exports = __webpack_public_path__ + "img/chrome-logo.3ade7888.png";